import { ICompany } from "@/models/Company";
import { ensureIntegratedPlatforms } from "@/lib/onboarding/integratedPlatforms";

export function isUserInOnboarding(user: { isInOnboarding?: boolean } | null | undefined): boolean {
  return !!user?.isInOnboarding;
}

export function isCrmConfigured(company: ICompany): boolean {
  if (!company) return false;

  if (!company?.integratedPlatforms) return true;
  const integrated = ensureIntegratedPlatforms(company);
  return Object.values(integrated.crm).some(Boolean);
  return false;
}

export function isAdsConfigured(company: ICompany): boolean {
  if (!company) return false;

  if (!company?.integratedPlatforms) return true;
  const integrated = ensureIntegratedPlatforms(company);
  return Object.values(integrated.ads).some(Boolean);
  return false;
}

export function isHcpCrmConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.crm.houseCallPro;
}

export function isServiceTitanCrmConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.crm.serviceTitan;
}

export function isServiceFusionCrmConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.crm.serviceFusion;
}

export function isJobberCrmConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.crm.jobber;
}


export function isCIConfigured(company: ICompany): boolean {
  if (!company) return false;
  if (!company?.integratedPlatforms) return true;
  if (company?.integratedPlatforms?.ci) return true;
  return false;
}



export function isCrmCredentialsConfigured(company: ICompany): boolean {
  if (!company) return false;
  if (
    (company?.crmAppKeys?.crmName && company?.crmAppKeys.crmApiKey) ||
    (company?.jobberClientId && company?.jobberClientSecret && company?.jobberRefreshToken && company?.jobberAccessToken) ||
    (company?.serviceFusionClientId && company?.serviceFusionClientSecret) ||
    (company?.stClientId && company?.stClientSecret && company?.stAppKey && company?.stTenantId)
  ) {
    return true;
  }
  return false;
}


export function isAdsCredentialsConfigured(company: ICompany): boolean {
  if (!company) return false;

  if (
    (company?.googleAccessToken && company?.googleRefreshToken) ||
    (company?.microsoftAccessToken && company?.microsoftRefreshToken) ||
    (company?.facebookAccessToken && company?.facebookAccessTokenExpiresAt && company?.facebookUserId && company?.facebookUserName && company?.facebookUserEmail)
  ) {
    return true;
  }
  return false;
}

export function isGoogleAdsCredentialsConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.ads.googleAds;
}

export function isBingAdsCredentialsConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.ads.microsoftAds;
}

export function isMetaAdsCredentialsConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.ads.metaAds;
}

export function isYelpAdsCredentialsConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.ads.yelpAds;
}

export function isAngiAdsCredentialsConfigured(company: ICompany | null | undefined): boolean {
  if (!company) return false;
  const integrated = ensureIntegratedPlatforms(company);
  return !!integrated.ads.angiAds;
}


export function isCICredentialsConfigured(company: ICompany): boolean {
  if (!company) return false;

  if (
    company?.linkedCallRailAccounts && company?.linkedCallRailAccounts.length > 0
  ) {
    return true;
  }
  return false;
}